import React, { useState } from 'react';
import { UserDetails } from 'api/usersApi';
import UserContext from './userContext';

interface UserProviderProps {
  children: React.ReactNode;
}

const UserProvider = ({ children }: UserProviderProps) => {
  const [user, setUser] = useState<UserDetails | null>(null);
  const [username, setUsername] = useState<string>('');
  const [userList, setUserList] = useState<UserDetails[]>([]);

  return (
    <UserContext.Provider
      value={{ user, setUser, username, setUsername, userList, setUserList }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
